import React, { useCallback, useEffect } from "react";
import styles from "./employees.module.scss";
import { cn } from "utils";
import Input from "components/Input";
import Checkbox from "components/Checkbox";
import Select from "components/Select";
import Radio from "components/Radio";
import Button from "components/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmployeeInputs, employeeSchema } from "./const";

const AddEditEmployee = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(employeeSchema),
    defaultValues: {
      [EmployeeInputs.WORK_FROM_HOME]: "yes",
    },
  });

  useEffect(() => {
    console.log({ errors });
  }, [errors]);

  const onSubmit = useCallback((values) => {
    console.log({ values });
  }, []);

  return (
    <form
      className={cn(styles["add-edit-employee-container"])}
      onSubmit={handleSubmit(onSubmit)}
    >
      <h3 className={styles["title"]}>Add Employee</h3>
      <div className={styles["personal-info-container"]}>
        <p className={styles["info-title"]}>Personal Information</p>
        <div className={cn(styles["personal-info-form"], "")}>
          <div className="row g-3">
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="First Name*"
                variant="flat"
                {...register(EmployeeInputs.FIRSTNAME)}
                error={!!errors[EmployeeInputs.FIRSTNAME]}
                errorText={errors[EmployeeInputs.FIRSTNAME]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Middle Name*"
                variant="flat"
                containerClasses="col"
                {...register(EmployeeInputs.MIDDLENAME)}
                error={!!errors[EmployeeInputs.MIDDLENAME]}
                errorText={errors[EmployeeInputs.MIDDLENAME]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Last Name*"
                variant="flat"
                containerClasses="col"
                {...register(EmployeeInputs.LASTNAME)}
                error={!!errors[EmployeeInputs.LASTNAME]}
                errorText={errors[EmployeeInputs.LASTNAME]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Social Security Number*"
                variant="flat"
                containerClasses="col"
                {...register(EmployeeInputs.SOCIAL_SECURITY_NUMBER)}
                error={!!errors[EmployeeInputs.SOCIAL_SECURITY_NUMBER]}
                errorText={
                  errors[EmployeeInputs.SOCIAL_SECURITY_NUMBER]?.message
                }
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Birth Date*"
                variant="flat"
                type="date"
                containerClasses="col"
                {...register(EmployeeInputs.BIRTH_DATE)}
                error={!!errors[EmployeeInputs.BIRTH_DATE]}
                errorText={errors[EmployeeInputs.BIRTH_DATE]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Marital Status"
                placeholder="Select status"
                options={[
                  {
                    label: "Married",
                    value: "Married",
                  },
                  {
                    label: "Unmarried",
                    value: "Unmarried",
                  },
                ]}
                {...register(EmployeeInputs.MARITAL_STATUS)}
                error={!!errors[EmployeeInputs.MARITAL_STATUS]}
                errorText={errors[EmployeeInputs.MARITAL_STATUS]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Apt, Unit, Flr, Ste, Bldg #"
                variant="flat"
                containerClasses="col-lg-4 col-md-6 col-12"
                {...register(EmployeeInputs.ADDRESS)}
                error={!!errors[EmployeeInputs.ADDRESS]}
                errorText={errors[EmployeeInputs.ADDRESS]?.message}
              />
            </div>
          </div>
          <div className="row g-3 mt-3">
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="City*"
                variant="flat"
                {...register(EmployeeInputs.CITY)}
                error={!!errors[EmployeeInputs.CITY]}
                errorText={errors[EmployeeInputs.CITY]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="State*"
                placeholder="Select state"
                options={[
                  {
                    label: "State 1",
                    value: "State 1",
                  },
                  {
                    label: "State 2",
                    value: "State 2",
                  },
                ]}
                {...register(EmployeeInputs.STATE)}
                error={!!errors[EmployeeInputs.STATE]}
                errorText={errors[EmployeeInputs.STATE]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Zip Code*"
                variant="flat"
                {...register(EmployeeInputs.ZIP_CODE)}
                error={!!errors[EmployeeInputs.ZIP_CODE]}
                errorText={errors[EmployeeInputs.ZIP_CODE]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Email"
                variant="flat"
                {...register(EmployeeInputs.EMAIL)}
                error={!!errors[EmployeeInputs.EMAIL]}
                errorText={errors[EmployeeInputs.EMAIL]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Home Phone"
                variant="flat"
                {...register(EmployeeInputs.HOME_PHONE)}
                error={!!errors[EmployeeInputs.HOME_PHONE]}
                errorText={errors[EmployeeInputs.HOME_PHONE]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Cell Phone"
                variant="flat"
                {...register(EmployeeInputs.CELL_PHONE)}
                error={!!errors[EmployeeInputs.CELL_PHONE]}
                errorText={errors[EmployeeInputs.CELL_PHONE]?.message}
              />
            </div>
          </div>
          <div className="pt-3">
            <Checkbox
              label="Send Portal Registration Email."
              {...register(EmployeeInputs.IS_REG_EMAIL)}
            />
          </div>
        </div>
      </div>
      <div className={cn(styles["eligibilty-info-container"], "mt-4")}>
        <p className={styles["info-title"]}>Eligibilty Information</p>
        <form className={cn(styles["eligibilty-info-form"], "container-fluid")}>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Hide Status"
                options={[
                  {
                    label: "Status 1",
                    value: "Status 1",
                  },
                  {
                    label: "Status 2",
                    value: "Status 2",
                  },
                ]}
                {...register(EmployeeInputs.HIDE_STATUS)}
                error={!!errors[EmployeeInputs.HIDE_STATUS]}
                errorText={errors[EmployeeInputs.HIDE_STATUS]?.message}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Medical Insurance Availibily"
                options={[
                  {
                    label: "Yes",
                    value: "Yes",
                  },
                  {
                    label: "No",
                    value: "No",
                  },
                ]}
                {...register(EmployeeInputs.MEDICAL_INSURANCE_AVAILABILITY)}
                error={!!errors[EmployeeInputs.MEDICAL_INSURANCE_AVAILABILITY]}
                errorText={
                  errors[EmployeeInputs.MEDICAL_INSURANCE_AVAILABILITY]?.message
                }
              />
            </div>
          </div>
        </form>
      </div>
      <div className={cn(styles["work-info-container"], "mt-4")}>
        <p className={styles["info-title"]}>Work Information</p>
        <form className={cn(styles["work-info-form"], "container-fluid")}>
          <h4 className={styles["label"]}>Primarily Work From Home</h4>
          <div className={styles["radio-group"]}>
            <Radio
              name="workfrom-hom-group"
              value="yes"
              label="Yes"
              {...register(EmployeeInputs.WORK_FROM_HOME)}
            />
            <Radio
              name="workfrom-hom-group"
              value="no"
              label="No"
              {...register(EmployeeInputs.WORK_FROM_HOME)}
            />
          </div>
          <div className="row mt-3">
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Work Location*"
                options={[
                  {
                    label: "Springfiled, Indiana",
                    value: "Springfiled, Indiana",
                  },
                ]}
                {...register(EmployeeInputs.WORK_LOCATION)}
                error={!!errors[EmployeeInputs.WORK_LOCATION]}
                errorText={errors[EmployeeInputs.WORK_LOCATION]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Work Time Zone*"
                options={[
                  {
                    label: "IST",
                    value: "IST",
                  },
                ]}
                {...register(EmployeeInputs.WORK_TIME_ZONE)}
                error={!!errors[EmployeeInputs.WORK_TIME_ZONE]}
                errorText={errors[EmployeeInputs.WORK_TIME_ZONE]?.message}
              />
            </div>
          </div>
        </form>
      </div>
      <div className={cn(styles["wage-info-container"], "mt-4")}>
        <p className={styles["info-title"]}>Wage Information</p>
        <form className={cn(styles["wage-info-form"], "container-fluid")}>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <Input
                fullWidth
                label="Wage*"
                variant="flat"
                {...register(EmployeeInputs.WAGE)}
                error={!!errors[EmployeeInputs.WAGE]}
                errorText={errors[EmployeeInputs.WAGE]?.message}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Wage Period"
                options={[
                  {
                    label: "WP",
                    value: "WP",
                  },
                ]}
                {...register(EmployeeInputs.WAGE_PERIOD)}
                error={!!errors[EmployeeInputs.WAGE_PERIOD]}
                errorText={errors[EmployeeInputs.WAGE_PERIOD]?.message}
              />
            </div>
          </div>
          <div className={cn("mt-4 row")}>
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="FLSA Overtime Exempt Status*"
                options={[
                  {
                    label: "Exempt",
                    value: "Exempt",
                  },
                ]}
                {...register(EmployeeInputs.OVERTIME_EXEMPT_STATUS)}
                error={!!errors[EmployeeInputs.OVERTIME_EXEMPT_STATUS]}
                errorText={
                  errors[EmployeeInputs.OVERTIME_EXEMPT_STATUS]?.message
                }
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Select
                fullWidth
                label="Supplement Tax Method"
                options={[
                  {
                    label: "Flat",
                    value: "Flat",
                  },
                ]}
                {...register(EmployeeInputs.SUPPLEMENT_TAX_METHOD)}
                error={!!errors[EmployeeInputs.SUPPLEMENT_TAX_METHOD]}
                errorText={
                  errors[EmployeeInputs.SUPPLEMENT_TAX_METHOD]?.message
                }
              />
            </div>
          </div>
        </form>
      </div>
      <div className={styles["bottom-container"]}>
        <Button buttonType="flat" type="submit">
          Add Employee
        </Button>
        <Button variant="text">Cancel</Button>
      </div>
    </form>
  );
};

export default AddEditEmployee;
